import { Globals } from '../../globals';
import { Observable } from 'rxjs';
import { Component,  OnInit } from '@angular/core';
import { IonRouterOutlet, ModalController, NavController, ToastController } from '@ionic/angular';
import { Router, NavigationStart, Event as NavigationEvent } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {


  public pageName = this.globals.pageName;
  public displayHeader = this.globals.displayHeader;
  public backButtonDefaultHref = this.globals.backButtonDefaultHref;

  public isL: Observable<boolean> = this.globals.isLoadingSubject$;

  constructor(public globals : Globals,
    private router: Router,
    private modalController: ModalController) {
      router.events
      .subscribe((event: NavigationEvent) => {
          if(event instanceof NavigationStart) {
            //console.log('router result:',event.url);
            let urlString: String = event.url;
            const parts = urlString.split('/');
            const lastPart = parts[parts.length - 1];
            // If you want to capitalize the first letter of each word:
            let displayName = lastPart
              .split(/(?=[A-Z][a-z]*$)/)
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ');

            this.globals.pageName.next(displayName);
            this.globals.backButtonDefaultHref?.next(undefined);
          }
      })
  }

  ngOnInit() {

  }

}
